import { updateCulture, getCulture } from 'lib/helpers';
import { authenticationLoaders } from '../../domain/loaders/authenticationLoaders';
import React, { useState } from 'react';
import { SingleSelect } from './select/base/SingleSelect';
import { OptionProps } from 'react-select';

const options: Record<string, string> = {
    'ru-RU': 'Русский',
    'en-US': 'English',
}

type Culture = {
    name: string,
}

function getOptionValue(option: Culture) {
    return option.name;
}

function getOptionLabel(option: Culture) {
    return options[option.name];
}

const cultures = [{ name: 'ru-RU' }, { name: 'en-US' }];

export function ChangeLanguage() {
    const [culture, setCulture] = useState({ name: getCulture() });

    async function onChange(selected: Culture | null) {
        if (selected?.name == culture?.name) {
            return;
        }

        if (selected?.name) {
            setCulture(selected);

            await authenticationLoaders.changeLang(selected?.name ?? "");
            updateCulture(selected?.name ?? "");
            window.location.reload();
        }
    }

    return (
        <SingleSelect<Culture>
            options={cultures}
            value={culture}
            getLabel={getOptionLabel}
            getValue={getOptionValue}
            onChange={onChange}
            isClearable={false}
            isSearchable={false}
            className='language-switcher'
            components={{
                DropdownIndicator: Globe,
            }}
        />);
}

function Globe() {
    return (
        <i className='fas fa-globe px-2'></i>
    )
}